// extracted by mini-css-extract-plugin
export default {"container":"PaymentSystems_container__SSX-Q","tips_container":"PaymentSystems_tips_container__6Gi87","edit":"PaymentSystems_edit__35BdN"};